var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('zx-table',{attrs:{"tableData":_vm.tableData,"option":_vm.table,"page":_vm.page,"searchDesc":_vm.searchDesc},on:{"searchSubmit":_vm.searchSubmit,"refresh-change":_vm.getlist,"refreshBtn":_vm.refreshBtn}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }